/**
 * Supabase Client — Real Implementation
 * Handles auth for Consoome: email/password + Google OAuth
 */
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('❌ Missing Supabase env vars. Check .env.local');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// ── Sign up with email + password ──────────────────────────────
export async function signUpWithEmail(email, password, fullName) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: { full_name: fullName },
    },
  });
  if (error) throw new Error(error.message);
  return data;
}

// ── Sign in with email + password ──────────────────────────────
export async function signInWithEmail(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw new Error(error.message);
  return data;
}

// ── Sign in with Google OAuth ───────────────────────────────────
export async function signInWithGoogle() {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: 'https://www.consoome.com',
    },
  });
  if (error) throw new Error(error.message);
  return data;
}

// ── Sign out ────────────────────────────────────────────────────
export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) throw new Error(error.message);
  localStorage.removeItem('sb_token');
}

// ── Get current session ─────────────────────────────────────────
export async function getCurrentSession() {
  const { data, error } = await supabase.auth.getSession();
  if (error) return null;
  return data.session;
}

// ── Get JWT token for API calls ─────────────────────────────────
export async function getAuthToken() {
  const session = await getCurrentSession();
  const token = session?.access_token || null;
  if (token) localStorage.setItem('sb_token', token);
  return token;
}

// ── Password reset ───────────────────────────────────────────────
export async function resetPassword(email) {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: 'https://www.consoome.com',
  });
  if (error) throw new Error(error.message);
}
